import { useEffect, useState } from "react"
import { useParams } from "react-router-dom"
import * as docx from "docx-preview"
import { useDispatch } from "react-redux"
import { useAppSelector } from "../../../stateManagement/hooks/redux"
import { getItemWebStorage } from "../../../features/webStorageSaver"
import { customFetchFileCUBA } from "../../../api/custom/documentsApi"
import { showToastMessage } from "../../../stateManagement/reducers"
import { Loader } from "../../loaders/Loader"

export default function CustomDocumentViewerDOCX() {
    const dispatch = useDispatch()
    const { id, entityId }: any = useParams()
    const restAuthToken = useAppSelector(state => state.customAuth.customAuthToken)
    const [documentIsLoading, setDocumentIsLoading] = useState<boolean>(true)
    const currentConfig = getItemWebStorage('currentConfig')
    const { cardAdditionalItems } = currentConfig
    const cardAdditionalItem = cardAdditionalItems.find((item: any) => item?.id === id)
    const docxViewerDivId = "document-docx-viewer-div"

    async function getDocumentFile() {
        setDocumentIsLoading(true)
        const { openDataOptions: restAuthRequestOptions, api, apiType } = cardAdditionalItem ?? {}
        const { downloadDocument: downloadDocumentApi } = api ?? {}
        let file
        if (apiType === "jmix") {

        } else if (apiType === "cuba") {
            file = await customFetchFileCUBA(downloadDocumentApi, restAuthToken, restAuthRequestOptions, false, entityId)
        }
        if (file) {
            if (file instanceof Blob) {
                let element: any = document.getElementById(docxViewerDivId)
                var options = { inWrapper: true, ignoreWidth: false, pageBreaks: true, ignoreLastRenderedPageBreak: true }
                docx.renderAsync(file, element, undefined, options)
            } else {
                dispatch(showToastMessage({ messageText: "Возникла ошибка при загрузке документа для просмотра", messageType: "error" }))
            }
        }
        setDocumentIsLoading(false)
    }

    useEffect(() => {
        if (restAuthToken) {
            getDocumentFile()
        }
    }, [restAuthToken, id, entityId])

    return (
        <>
            {documentIsLoading && <Loader />}
            <div id={docxViewerDivId}/>
        </>
    )
}
